import { mapActions, mapState } from 'vuex';

const LEVEL_CONFIG_TYPE = {
  LEVEL: 'level',
  SUB_LEVEL: 'sub_level',
};
const SUBJECT_ID = {
  ENGLISH: 5,
  LITERATURE: 15,
};
export default {
  methods: {
    ...mapActions('student_care', ['getLevelConfig']),
  },
  async created() {
    await this.getLevelConfig();
  },
  computed: {
    ...mapState('student_care', ['levelConfig']),
    subLevel() {
      let subLevel = [];
      if (this.levelConfig.length > 0) {
        subLevel = _.get(this.levelConfig.find((e) => e.type === LEVEL_CONFIG_TYPE.SUB_LEVEL), 'data', []);
        subLevel.unshift({ id: -1, name: 'Không có sub level' });
      }
      return subLevel;
    },
    levelEnglish() {
      let level = [];
      if (this.levelConfig.length > 0) {
        level = _.get(this.levelConfig.find((e) => e.type === LEVEL_CONFIG_TYPE.LEVEL), 'data', []);
        level = level.filter((e) => e.subjectId === SUBJECT_ID.ENGLISH);
        level = level.map((e) => {
          if (e.id !== 22) {
            return {
              id: e.id,
              name: e.name,
              children: this.subLevel,
            };
          } return {
            id: e.id,
            name: e.name,
          };
        });
        level.unshift({
          id: -1,
          name: 'Không có level',
        });
      }
      return level;
    },
    levelDefault() {
      let level = [];
      if (this.levelConfig.length > 0) {
        level = _.get(this.levelConfig.find((e) => e.type === LEVEL_CONFIG_TYPE.LEVEL), 'data', []);
        level = level.filter((e) => (e.subjectId !== SUBJECT_ID.LITTERATURE && e.subjectId !== SUBJECT_ID.ENGLISH));
        level.unshift({
          id: -1,
          name: 'Không có level',
        });
      }
      return level;
    },
    treeListProgram() {
      let result = [];
      result = JSON.parse(JSON.stringify(this.listProgram));
      if (this.levelEnglish.length === 0 || this.levelDefault.length === 0) return result;
      const levelEnglish = JSON.parse(JSON.stringify(this.levelEnglish));
      const levelDefault = JSON.parse(JSON.stringify(this.levelDefault));
      result.map((e) => {
        const tempElement = _.cloneDeep(e);
        tempElement.name = tempElement.title;
        tempElement.fakeId = tempElement.id.toString();
        // e.name = e.title;
        // e.fakeId = e.id.toString();
        if (tempElement.subject_id === 3) {
          tempElement.children = Object.assign([], levelEnglish);
          tempElement.children = tempElement.children.map((child) => {
            const tempChild = _.cloneDeep(child);
            tempChild.fakeId = `${tempElement.id.toString()}_${tempChild.id.toString()}`;
            if (tempChild.children) {
              tempChild.children = tempChild.children.map((grandChild) => {
                const tempGrandChild = _.cloneDeep(grandChild);
                tempGrandChild.fakeId = `${tempElement.id.toString()}_${tempChild.id.toString()}_${tempGrandChild.id.toString()}`;
                tempGrandChild.programLevelName = `${tempElement.name} - ${tempChild.name} - ${tempGrandChild.name}`;
                return tempGrandChild;
              });
            } else {
              tempChild.programLevelName = `${tempElement.name} - ${tempChild.name}`;
            }
            return tempChild;
          });
        } else if (tempElement.subject_id !== 15) {
          tempElement.children = Object.assign([], levelDefault);
          tempElement.children = tempElement.children.map((child) => {
            const tempChild = _.cloneDeep(child);
            tempChild.fakeId = `${tempElement.id.toString()}_${tempChild.id.toString()}`;
            tempChild.programLevelName = `${tempElement.name} - ${tempChild.name}`;
            return tempChild;
          });
        } else {
          tempElement.programLevelName = `${tempElement.name}`;
          tempElement.fakeId = tempElement.id.toString();
        }
        return Object.assign(e, tempElement);
      });
      return result;
    },
  },
};
